import { BulkActionContainerCol, Col, Table, TableActionBarRow, } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useState } from "react";
import { BulkActionCount } from "../table/BulkActionCount";

import { useTableSelection } from "../../hooks/table/useTableSelection";

import { Search } from "../search/Search";
import { TableCellLink } from "../table/TableCellLink";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useCoupons } from "../../hooks/coupons/useCoupons";
import { ControlcenterMelcoModelsCouponListItem } from "melco-shared-logic";
import { AddNewCouponDrawer } from "./drawer/AddNewCouponDrawer";
import { EditCouponDrawer } from "./drawer/EditCouponDrawer";
import { BulkActionDeleteCoupons } from "./BulkActionDeleteCoupons";
import { BulkActionDeactivateCoupons } from "./BulkActionDeactivateCoupons";

type CouponsListPropTypes = {
  openAddNewCouponDrawer: boolean;
  setAddNewCouponDrawerFunction: (v: boolean) => void;
};

export const typeLabels = {
  1: "coupons.table.type.1",
  2: "coupons.table.type.2",
} as const;

export const CouponsList: React.FC<CouponsListPropTypes> = ({
  openAddNewCouponDrawer,
  setAddNewCouponDrawerFunction,
}) => {
  const { t } = useTranslation();
  const { roles } = useRolesContext();
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    // filtersChange,
    refetch,
    //  searchQuery,
    searchQueryChange,
  } = useCoupons();

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editCouponDetails, setEditCouponDetails] =
    useState<ControlcenterMelcoModelsCouponListItem>();

  const handleEditClick = (
    item: ControlcenterMelcoModelsCouponListItem
  ) => {
    setEditCouponDetails(item);
    setEditDrawerAction(true);
  };

  const columns = [
    {
      title: t("coupons.table.column.id"),
      key: "id",
      sorter: true,
      width: 110,
      render: (
        rowObj: ControlcenterMelcoModelsCouponListItem
      ) =>

        <TableCellLink
          onClick={() => {
            handleEditClick(rowObj);
          }}
          to={""}
        >
          {rowObj?.id}
        </TableCellLink>

    },
    {
      title: t("coupons.table.column.code"),
      key: "code",
      dataIndex: "code",
      sorter: true,
      width: 200
    },
    {
      title: t("coupons.table.column.type"),
      key: "type",
      // dataIndex: "type",
      sorter: true,
      width: 100,
      // render: (value: ControlcenterMelcoModelsCouponListItem) => t(`coupons.table.type.${value?.type}` as const),
      render: (value: ControlcenterMelcoModelsCouponListItem) => {
        const key = typeLabels[value.type as 1 | 2];
        return key ? t(key) : "";
      }
    },
    {
      title: t("coupons.table.column.description"),
      key: "description",
      dataIndex: "description",
      sorter: true,
      width: 250
    },

    {
      title: t("coupons.table.column.value"),
      key: "value",
      dataIndex: "value",
      sorter: true,
      width: 100,
    },
    {
      title: t("coupons.table.column.count"),
      key: "usage_count",
      dataIndex: "usage_count",
      sorter: true,
      width: 100,
    },
    {
      title: t("coupons.table.column.start_date"),
      key: "start_date",
      // dataIndex: "last_opened",
      sorter: true,
      width: 150,
      render: (rowObj: any) => (
        <div>
          <span>
            {rowObj.start_date
              ? new Date(rowObj.start_date).toLocaleString()
              : ""}
          </span>
        </div>
      ),
    },
  ];

  const setEditDrawerAction = (action: boolean) => {
    setEditDrawerOpen(action);
    refetch();
  };

  const setDrawerAction = (action: boolean) => {
    setDrawerOpen(action);
    setAddNewCouponDrawerFunction(action);
    refetch();
  };

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ControlcenterMelcoModelsCouponListItem>(
      () => { },
      {
        fixed: "left",
      }
    );

  return (
    <>
      <TableActionBarRow>
        <div></div>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        {roles.URL_FORWARDS_DELETE && (
          <BulkActionContainerCol>
            <BulkActionCount selectedCount={selectedRowKeys.length} />
            <BulkActionDeleteCoupons
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              refetch={refetch}
            />

            <BulkActionDeactivateCoupons
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              refetch={refetch}
            />
          </BulkActionContainerCol>
        )}
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        rowSelection={roles.URL_FORWARDS_DELETE ? rowSelection : undefined}
        onRow={onRow}
        noDataMessage={t("coupons.designs.no_data_message")}
        errorComponent={errorComponent}
      />

      {(
        <AddNewCouponDrawer
          isDrawerOpen={openAddNewCouponDrawer}
          setDrawerOpen={setDrawerAction}
        />
      )}
      {
        isEditDrawerOpen &&
        editCouponDetails && (
          <EditCouponDrawer
            isDrawerOpen={isEditDrawerOpen}
            setDrawerOpen={setEditDrawerAction}
            CouponDetails={editCouponDetails}
          />
        )}
    </>
  );
};
